export const CAR_DELIVERY_OPTIONS = {
  Pickup: "Pickup",
  Dropoff: "Dropoff",
};
